import { Input } from "components/ui/input";
import { cn } from "lib/utils";

import { CopyKeyButton } from "./copy-key-button";

export interface UsageKeyInputProps {
  id?: string;
  value: string;
  onChange: (key: string) => void;
  label: string;
  copyLabel: string;
  hint?: string;
  placeholder?: string;
  error?: string;
  readOnly?: boolean;
  className?: string;
  inputClassName?: string;
}

/** A key typed whole, with a copy button inside the box and the reason it cannot be saved
 * beneath it. */
export const UsageKeyInput = ({
  id,
  value,
  onChange,
  label,
  copyLabel,
  hint,
  placeholder,
  error,
  readOnly,
  className,
  inputClassName,
}: UsageKeyInputProps) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <div className="relative">
      <Input
        id={id}
        className={cn("h-8 pr-8 font-mono text-xs", inputClassName, error && "border-destructive")}
        value={value}
        disabled={readOnly}
        aria-label={label}
        aria-invalid={Boolean(error)}
        title={hint}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      <CopyKeyButton
        value={value}
        label={copyLabel}
        className="absolute right-0.5 top-1/2 -translate-y-1/2"
      />
    </div>
    {error && (
      <p role="alert" className="text-xs text-destructive">
        {error}
      </p>
    )}
  </div>
);
